import { render, staticRenderFns } from "./PaymentSidebar.vue?vue&type=template&id=07d8e2ca&scoped=true&"
import script from "./PaymentSidebar.vue?vue&type=script&lang=js&"
export * from "./PaymentSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07d8e2ca",
  null
  
)

export default component.exports